import { Assignments, GetAssignmentsForGuest, Activity } from "../slices/types";

export const formatFullName = (
  firstName: string | undefined,
  lastName: string | undefined
) => ((firstName ?? "") + " " + (lastName ?? "")).trim();

export const formatInitials = (
  firstName: string | undefined,
  lastName: string | undefined
) => {
  let initials = "";
  if ((firstName ?? "").length > 0) initials = firstName![0];
  if ((lastName ?? "").length > 0) initials += lastName![0];
  return initials;
};

export const formatPrimaryName = (
  primaryGuestId: string | undefined,
  primaryFirstName: string | undefined,
  primaryLastName: string | undefined
) => {
  if (primaryGuestId == "") return "";
  return formatFullName(primaryFirstName, primaryLastName);
};

export const splitFullName = (
  fullName: string | null
): { firstName: string; lastName: string } => {
  if (fullName == null || fullName === "") {
    return { firstName: "unknown", lastName: "unknown" };
  }
  const tokens = fullName.split(" ");
  let lastName = "";
  if (tokens.length > 1) {
    lastName = tokens.pop()!;
  }
  const firstName = tokens.join(" ");
  return { firstName, lastName };
};

// NumberInput can set the value of the field to blank.
// Typescript's typings get in the way for testing, so we isolate our dangerous code in this function.
export function isNumberInputBlank(value: number) {
  return (value as any) === "";
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function stringCompare(a: string | undefined, b: string | undefined) {
  if (a === b) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  return a.localeCompare(b, undefined, { sensitivity: "base" });
}

export const getActivityAssignmentsText = (
  assignments: Assignments | undefined,
  guestId: string | undefined,
  activities: Record<string, Activity> | undefined
) => {
  if (assignments == null || activities == null || guestId == null) return "";
  // guestsAssignments[activityId] has Assignment
  const guestAssignments = GetAssignmentsForGuest(assignments, guestId);
  const assignmentBits: string[] = [];
  for (const activityId of Object.keys(guestAssignments ?? {})) {
    const activity = activities[activityId];
    const assignment = guestAssignments[activityId];
    const activityBits: string[] = [];
    activityBits.push(activity.description);
    const qty = guestAssignments[activityId].quantity;
    const needParens = assignment.comment.length > 0 || qty > 1;
    if (needParens) {
      activityBits.push("(");
      if (qty > 1) {
        activityBits.push(`${qty}`);
        if (assignment.comment.length > 0) activityBits.push("-");
      }
      if (assignment.comment.length > 0) activityBits.push(assignment.comment);
      activityBits.push(")");
    }
    assignmentBits.push(activityBits.join(""));
  }
  const assignmentText = assignmentBits.join(", ");
  return assignmentText;
};
